<template>
  <div class="container my-3"> 
    <div class="card">
        <div class="card-header bg-success">
           <h3 class="text-center" style="color:#fff; font-size:1.4em"> Reset Password</h3>
           <p class="text-center" style="color:#fff;" v-if="tokenSuccessful"> Please Enter Your New Password </p>
        </div>
        <div class="card-body">
            <form @submit.prevent="resetPassword" v-if="tokenSuccessful">
                <div class="form-group">
                    <label for="email">New Password</label>
                    <input type="password" class="form-control" id="email" 
                    aria-describedby="emailHelp" v-model="password" required>
                </div>
                <div class="form-group">
                    <label for="password">Confirm password</label >
                    <input type="password" class="form-control" id="password" v-model="cPassword" required>
                </div>
                 <p class="text-danger text-center" v-if="passwordError"> {{passwordError}} </p>
                <button type="submit" class="btn btn-success">Reset Password
                    <div class="spinner-grow" role="status" v-if="loading">
                        <span class="sr-only">Loading...</span>
                    </div>
                </button>
            </form>

            <div class="container" v-else-if="errorMessage">
                <div class="row">
                    <div class="col">
                      <h3 class="m-5" > {{errorMessage}}.  <a href="/user/login">Try Again</a> </h3>
                    </div>
                </div>
            </div>

            <div class="container" v-else-if="success">
                <div class="row">
                    <div class="col">
                       <h3 class="m-5"> Your password has been reset successfully! Please <a href="/user/login">Sign In</a> with your new password  </h3>
                    </div>
                </div>
            </div>
        </div>
    </div> 
  </div>
</template>

<script>
import url from '../URL'

export default {
    data() {
        return {
            loading:false,
            password:null,
            cPassword:null,
            success : false,
            tokenSuccessful:false,
            errorMessage:null,
            token:null,
            passwordError:null,
        }
    }, 
    methods: {
        validateToken() {
            const token = this.$route.query.token
           this.$http.post(`${this.apiurl}/api/actioncommons/passwordresettoken/validate`,
           {"token":token})
           .then(response => {
               if(response.status === 200) {
                 this.tokenSuccessful = true
               }
               console.log(response)
           }).catch(err => {
               console.log(err)
               if(err.response) {
                   if(err.response.status === 400 ) {
                       this.errorMessage = "Require access token"
                       
                   }else if(err.response.status === 404) {
                       this.errorMessage = "Invalid access token"
                       
                   }
               }
           })
        
        },
        resetPassword() {
          this.loading = true
          
           if(!this.password) {
             this.loading = false;
             this.passwordError = "Please Enter Your New Password"
             return
           }
           else if(this.password !== this.cPassword) {
               this.loading = false
               this.passwordError = "Password Do Not Match"
               return
           }
           this.$http.post(`${this.apiurl}/api/actioncommons/passwordreset`,
           {
            "password":this.password,
            "token":this.$route.query.token
            }).then(response => {
               if(response) {
                   if(response.statusText === "OK") {
                       this.loading = false;
                       this.success = true
                       this.tokenSuccessful = false;
                   }
               }
            }).catch(err => {
                if(err.response) {
                  this.loading = false
                  this.passwordError = err.response.data.password[0]
                }else if(err.request) {
                    this.loading = false;
                    this.passwordError = "Network Error.Try Again"
                    
                }
            })
        }
    },
    created() {
        this.validateToken()
    
    },
    computed:{
    apiurl(){
        return url()
    }
}
}
</script>

<style scoped>

</style>